module.exports = __webpack_public_path__ + "static/media/29ADMSPC36.5d5ef187.jpg";